import { ccOnboardingAvailableSteps } from 'components/features/creditCard/creditCardStore/constants'
import { CCOnboardingApiStep } from 'components/features/creditCard/creditCardStore/types'
import { useMemo } from 'react'
import useRouter from 'hooks/useRouter'


export const useNextStep = () => {
  const { location } = useRouter()
  const nextStep = useMemo(() => {
    const pageParams = new URLSearchParams(location.search)
    const nextStepRaw = pageParams.get('next-step') as CCOnboardingApiStep | null

    if (nextStepRaw && ccOnboardingAvailableSteps.has(nextStepRaw)) {
      return nextStepRaw
    }
    return null
  }, [location.search])

  return nextStep
}
